import React, { useState, useEffect } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";
import { toast, Bounce } from "react-toastify";

const ChangePassword = ({ data, setApiRun }) => {
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const { fetchPostData } = useFetchPost();

	const handleClose = () => {
		const changePasswordModal = document.getElementById("changePassword");
		changePasswordModal.classList.remove("show");
		changePasswordModal.style.display = "none";
	};

	const handleChangePassword = (event) => {
		setPassword(event.target.value);
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		// if (!password.trim()) {
		// 	setError("Please enter new password");
		// 	return;
		// }
		// Process the data or perform any actions
		const postData = {
			// product_key: data && data.product_key,
			// customer_id: data && data.customer_id,
			studio_id: data && data.customer_id,
			user_id: data && data.customer_user_uuid,
			inputs: {
				new_password: password,
			},
		};

		let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/change-password";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}

		if (responseData && responseData.status == "OK") {
			setApiRun(true); // customer list api run
			setPassword("");
			setError("");
			toast.success("Password changed successfully", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			toast.error("Error Occured ! try again.", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			console.warn("Something went wrong in password change");
		}

		// Close the modal
		const changePasswordModal = document.getElementById("changePassword");
		changePasswordModal.classList.remove("show");
		changePasswordModal.style.display = "none";
		// const backdrop = document.querySelector(".modal-backdrop");
		// backdrop.style.display = "none";
	};

	return (
		<div
			className="modal fade"
			id="changePassword"
			tabindex="-1"
			role="dialog"
			aria-labelledby="changePasswordLabel"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="changePasswordLabel">
							Change Password
						</h4>
					</div>
					<div className="modal-body">
						<form>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									New Password
								</label>
								<input
									type="text"
									className="form-control"
									id="new-password"
									name="password"
									value={password}
									onChange={handleChangePassword}
								/>
								{error && <div className="text-danger">{error}</div>}
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<span type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</span>
						<span type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Save changes
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/crm/modals/ChangePassword.jsx